export default (fullUri) => {
  return fullUri.replace('https://firebasestorage.googleapis.com/v0/b/diet-z.appspot.com/o/', '');
}